module.exports = __webpack_public_path__ + "img/arms-bg1.6116580e.png";